export const convertHexToRgba = ({
  hexCode,
  opacity = 1,
}: {
  hexCode: string
  opacity?: number
}) => {
  /* Allows both strings prefaced with # and those that are not */
  let hex = hexCode.replace('#', '')
  let opacityToUse = opacity

  /* Some codes have a shorthand, such as #FFF. This needs to be 6 characters long for RGBA */
  if (hex.length === 3) {
    hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`
  }

  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)

  /* Allows whole number based opacity values. */
  if (opacity > 1 && opacity <= 100) {
    opacityToUse = opacity / 100
  }

  return `rgba(${r},${g},${b},${opacityToUse})`
}
